/* eslint-disable max-statements */
type ArrowOffset = { left?: string; top?: string };

const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

export const getArrowOffsetDynamic = ({
  placement,
  referenceRect,
  floatingRect,
  x,
  y,
  withoutPortal,
  parentOffsets,
  floatingEl,
  arrowPadding = 12,
}: {
  placement: string;
  referenceRect: DOMRect;
  floatingRect: DOMRect;
  x: number;
  y: number;
  withoutPortal: boolean;
  parentOffsets: { top: number; left: number };
  floatingEl: HTMLElement;
  arrowPadding?: number;
}): ArrowOffset => {
  const base = placement.split('-')[0];
  const isVertical = base === 'top' || base === 'bottom';

  const refCenterViewportX = referenceRect.left + referenceRect.width / 2;
  const refCenterViewportY = referenceRect.top + referenceRect.height / 2;

  let refCenterX: number;
  let refCenterY: number;

  if (!withoutPortal) {
    refCenterX = refCenterViewportX + window.scrollX;
    refCenterY = refCenterViewportY + window.scrollY;
  } else {
    const op = floatingEl.offsetParent as HTMLElement | null;
    const opRect = op?.getBoundingClientRect();
    const opLeft = opRect?.left ?? 0;
    const opTop = opRect?.top ?? 0;
    const opScrollLeft = op?.scrollLeft ?? 0;
    const opScrollTop = op?.scrollTop ?? 0;

    refCenterX = refCenterViewportX - parentOffsets.left - opLeft + opScrollLeft;
    refCenterY = refCenterViewportY - parentOffsets.top - opTop + opScrollTop;
  }

  if (isVertical) {
    const leftPx = clamp(refCenterX - x, arrowPadding, floatingRect.width - arrowPadding);
    return { left: `${leftPx}px` };
  }

  const topPx = clamp(refCenterY - y, arrowPadding, floatingRect.height - arrowPadding);
  return { top: `${topPx}px` };
};
